import {
  Component,
  forwardRef,
  Injector,
  Input,
} from '@angular/core';
import { FormElement } from '../ui-form/form-element';
import { FormElementType } from '../ui-form/form-element-types';

export interface UiSelectOption {
  label: string;
  value: string;
}

@Component({
  selector: 'app-ui-select',
  templateUrl: './ui-select.component.html',
  styleUrls: ['./ui-select.component.less'],
  providers: [
    {
      provide: FormElement,
      useExisting: forwardRef(() => UiSelectComponent),
    },
  ],
})
export class UiSelectComponent extends FormElement<string, UiSelectComponent> {
  readonly type: FormElementType = FormElementType.Select;

  @Input() public label: string = '';
  @Input() public placeholder: string = '';
  @Input() public options: UiSelectOption[] = [];
  @Input() public override disabled: boolean = false;
  @Input() public size: 'large' | 'medium' | 'small' = 'medium';

  constructor(public override injector: Injector) {
    super(injector);
  }

  onValueChangeSelect(value: string | null): void {
    const stringValue = value === null || value === undefined ? '' : String(value);
    this.onValueChange(stringValue);
  }

  onOpenChange(isOpen: boolean): void {
    if (this.disabled) {
      return;
    }

    if (isOpen) {
      this.onFocus();
      this.onTouch();
    } else {
      this.onBlur();
    }
  }
}
